<div class="wrapper">
    <a href="javascript:void(0)" (click)="togglePicker()"><span class="ico pdf"></span>Archived Reports</a>
    <div class="picker" *ngIf="openPicker">
        <my-date-range-picker [options]="myDateRangePickerOptions"
                              (dateRangeChanged)="onDateRangeChanged($event)"
                              (dateSelected)="onDateSelected($event)"
        ></my-date-range-picker>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/pdf-selector/pdf-selector.component.html